class PilotDiscovery extends HTMLElement {
  connectedCallback() { this.load(); this.querySelector('[data-more]')?.addEventListener('click', () => { this.page = (this.page || 1) + 1; this.load(true); }); }
  async load(append = false) {
    const status = this.querySelector('[aria-live]');
    const result = this.querySelector('[data-results]');
    try {
      const url = new URL(this.dataset.product ? '/api/pilot/recommendations' : '/api/pilot/search', location.origin);
      if (this.dataset.product) url.searchParams.set('product_id', this.dataset.product);
      else url.searchParams.set('q', new URLSearchParams(location.search).get('q') || '');
      url.searchParams.set('page', this.page || 1);
      url.searchParams.set('limit', this.dataset.product ? 8 : 24);
      const response = await fetch(url);
      if (!response.ok) throw new Error('unavailable');
      const data = await response.json();
      if (!append) result.replaceChildren();
      for (const p of data.products) {
        const a = document.createElement('a'); a.className = 'pilot-card';
        if (!/^\/products\/[a-z0-9-]+$/.test(p.url)) continue;
        a.href = p.url;
        if (p.image && /^https:\/\/(?:cdn\.shopify\.com|[^/]+\.shopifycdn\.com)\//.test(p.image)) { const img = document.createElement('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; a.append(img); }
        const title = document.createElement('span'); title.textContent = p.title;
        const price = document.createElement('strong'); price.textContent = new Intl.NumberFormat('es-AR', {style:'currency',currency:'ARS',maximumFractionDigits:0}).format(p.price / 100);
        a.append(title, price); result.append(a);
      }
      status.textContent = data.total ? data.total + ' productos' : 'No encontramos productos.';
      const more = this.querySelector('[data-more]'); if (more) more.hidden = result.children.length >= data.total;
    } catch { status.textContent = 'No pudimos cargar los productos. Intenta nuevamente.'; }
  }
}
if (!customElements.get('pilot-discovery')) customElements.define('pilot-discovery', PilotDiscovery);
